<script lang="ts">
  import { MultiApplyExecutor } from "./MultiApply"
  import Translations from "../i18n/Translations"
  import LoginToggle from "../Base/LoginToggle.svelte"
  import Tr from "../Base/Tr.svelte"
  import type { MultiApplyParams } from "./MultiApply"
  import { ExclamationTriangle } from "@babeard/svelte-heroicons/solid/ExclamationTriangle"

  export let params: MultiApplyParams
  let p = params
  let state = p.state
  let t = Translations.t.multi_apply
  let featureId = p.tagsSource.data.id
  let featuresToApplyOn: Store<string[]> = p.featureIds
  if (featureId === undefined) {
    throw "MultiApply needs a feature id"
  }
  let applicator = MultiApplyExecutor.GetApplicator(featureId, params)
  let keysToApply: string[] = p.keysToApply
</script>

<LoginToggle {state} ignoreLoading>
  {#if $featuresToApplyOn.length > 0}
    {#if p.autoapply}
      <div class="border-interactive low-interaction p-2">
        <div class="flex items-center gap-x-2">
          <ExclamationTriangle class="w-16" />
          <div>{p.text}</div>
        </div>
        <div class="subtle text-sm">
          <Tr
            t={t.autoApply.Subs({
              attr_names: keysToApply.join(", "),
              count: "" + $featuresToApplyOn.length,
            })}
          />
        </div>
      </div>
    {:else}
      <button on:click={() => applicator.applyTaggingOnOtherFeatures()}>{p.text}</button>
    {/if}
  {/if}
</LoginToggle>
